import styled from 'styled-components';

import { utils } from '@desygner/ui-common-components';

export const StyledGridPreviewContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: ${({ theme }) => utils.rem(theme.Spacing.Size.XSmall)};
`;

export const StyledGuidesContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: ${({ theme }) => utils.rem(theme.Spacing.Size.Medium)};
`;

export const StyledGuidesContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: ${({ theme }) => utils.rem(theme.Spacing.Size.Small)};
`;

export const StyledInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => utils.rem(theme.Spacing.Size.XSmall)};
`;

export const StyledTitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => utils.rem(theme.Spacing.Size.XXSmall)};
`;
